import React, { useState, useEffect } from "react";
import { Space, Col, Row } from "antd";
import BusinessModal from "../business_pages/components/BusinessForm";
import SuccessModal from "../business_pages/components/SuccessModal";

const ContactSection = () => {
  const [isFormModalVisible, setIsFormModalVisible] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);

  return (
    <>
      <div style={{ marginBottom: -100 }}>
        <Row align="middle">
          <Col span={24} md={{ span: 12 }} xl={{ span: 8, offset: 4 }}>
            <img
              style={{ width: "100%" }}
              src="https://assets.siusk24.lt/business-page/envelope-party.svg"
            />
          </Col>
          <Col span={24} md={{ span: 12 }} xl={{ span: 9 }}>
            <div style={{ padding: 20 }}>
              <div className="header-title-3" style={{ marginBottom: 20 }}>
                {"Reikia verslui pritaikytų sprendimų?"}
              </div>
              <button
                className="get-the-deal"
                onClick={() => {
                  setIsFormModalVisible(true);
                }}
              >
                {"Gauti pasiūlymą"}
              </button>

              <Row gutter={[32, 32]} style={{ marginTop: '25px' }}>
                <Col span={24} lg={{ span: 12 }}>
                  <Space>
                    <img src="https://assets.siusk24.lt/business-page/envelope.svg" />
                    <div className="info-font nice-select">
                      <a href="mailto: pardavimai@siusk24.lt">
                        {"pardavimai@siusk24.lt"}
                      </a>
                    </div>
                  </Space>
                </Col>
                <Col span={24} lg={{ span: 12 }}>
                  <Space>
                    <img src="https://assets.siusk24.lt/business-page/phone.svg" />
                    <div className="info-font nice-select">
                      <a href="tel: +37065144446">{"+370 651 44 446"}</a>
                    </div>
                  </Space>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        {isFormModalVisible && (
          <BusinessModal
            setIsFormModalVisible={setIsFormModalVisible}
            setIsSuccessModalVisible={setIsSuccessModalVisible}
          />
        )}
        {isSuccessModalVisible && (
          <SuccessModal setIsSuccessModalVisible={setIsSuccessModalVisible} />
        )}
      </div>
    </>
  );
};

export default ContactSection;
